export const APP_URL = import.meta.env.APP_URL
export const CURRENT_TAG = import.meta.env.APP_CURRENT_TAG
export const APP_WEBSOCKET_URL = import.meta.env.APP_WEBSOCKET_URL

export const APP_API_URL = import.meta.env.APP_API_URL
export const APP_AUTH_API_URL = import.meta.env.APP_AUTH_API_URL

export const APP_CONFIG_IFRAME_EVENT_TYPE = import.meta.env.APP_CONFIG_IFRAME_EVENT_TYPE
